import React from 'react';
import { Drawer, Checkbox, Button, Divider } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './styleFilteredUserModal.css';

interface FilteredUserModalProps {
    visible: boolean;
    onClose: () => void;
    selectedRoles: string[];
    selectedGroups: string[];
    onRoleChange: (roles: string[]) => void;
    onGroupChange: (groups: string[]) => void;
    availableRoles: { label: string; value: string }[];
    availableGroups: { label: string; value: string }[];
}

const FilteredUserModal: React.FC<FilteredUserModalProps> = ({
    visible,
    onClose,
    selectedRoles,
    selectedGroups,
    onRoleChange,
    onGroupChange,
    availableRoles,
    availableGroups,
}) => {
    return (
        <Drawer
            title={<span style={{ fontWeight: 400, fontSize: 24, }}>
                <CloseOutlined
                    className="closeBut"
                    onClick={onClose}
                    style={{
                        marginLeft: 'auto',
                        cursor: 'pointer',
                    }}
                />
                Фильтр</span>}
            placement="right"
            onClose={onClose}
            open={visible}
            width={400}
            className="filtered-user-modal"
            footer={
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className="buttonModalSetting" onClick={onClose}>
                        Сохранить
                    </Button>
                </div>
            }
        >
            <div className="filter-section">
                <div className="filter-label">Роль</div>
                <Checkbox.Group
                    options={availableRoles}
                    value={selectedRoles}
                    onChange={onRoleChange}
                    style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                />
            </div>
            <div className="filter-section">
                <div className="filter-label">Группы</div>
                <Checkbox.Group
                    options={availableGroups}
                    value={selectedGroups}
                    onChange={onGroupChange}
                />
            </div>
        </Drawer>
    );
};

export default FilteredUserModal;
